
import { 
    GET_CONFIGURATION_OPTIONS,
    GET_CONFIGURATION_OPTIONS_SUCCESS,
    GET_CONFIGURATION_OPTIONS_FAIL, 
    GET_CONFIGURATION_OPTIONS_RESET,
} from "../actions/getConfigurationOptionsAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getConfigurationOptionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONFIGURATION_OPTIONS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_CONFIGURATION_OPTIONS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_CONFIGURATION_OPTIONS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_CONFIGURATION_OPTIONS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getConfigurationOptionsReducer;
